export default __webpack_public_path__ + "static/media/notewrote2.d4640c35.jpg";